import axios from "axios"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import Select from 'react-select'
import { toast } from "react-toastify"
import FormButton from "../../components/FormButton"
import { getId, getToken, usePermissions } from "../../user/User"

const ClientCreate = () => {
    const navigate = useNavigate()
    const options = []
    const durationOptions = [
        {
            value: 0,
            label: ""
        },
        {
            value: 1,
            label: "1 month"
        },
        {
            value: 3,
            label: "3 months"
        },
        {
            value: 6,
            label: "6 months"
        },
        {
            value: 12,
            label: "12 months"
        },
        {
            value: 24,
            label: "24 months"
        }
    ]

    const { permissions } = usePermissions(getId())
    useEffect(() => {
        if(permissions.client !== undefined && !permissions.client) {
            toast.error("You don't have permission to create clients!")
            navigate("/")
        }
    }, [permissions])
    
    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + "/api/providers", { headers: {
            "Authorization": "Bearer " + getToken()
        }}).then(res => {
            if(res.data == null) {
                return
            }

            res.data.forEach((provider, _) => {
                options.push({
                    value: provider.id,
                    label: provider.name
                })
            })
        }).catch(error => {
            console.log(error)
            toast.error("Unable to load providers")
        })
    })

    const [username, setUsername] = useState("")
    const [emailAddress, setEmailAddress] = useState("")
    const [provider, setProvider] = useState(0)
    const [duration, setDuration] = useState(1)
    const [expiryDate, setExpiryDate] = useState("")

    async function createClient() {
        axios.post(process.env.REACT_APP_API_URL + "/api/clients", JSON.stringify({
            "username": username,
            "email_address": emailAddress,
            "provider": provider,
            "duration": duration,
            "expiry_date": expiryDate === "" ? 0 : Math.floor(new Date(expiryDate).getTime() / 1000)
        }), { headers: {
            "Authorization": "Bearer " + getToken()
        }}).then(res => {
            toast.success("Created client " + username + " (#" + res.data.id + ").")
            navigate("/client/" + res.data.id)
        }).catch(error => {
            if (error.response) {
                var statusCode = error.response.status
                if(statusCode === 400) {
                    toast.error("Invalid request.")
                    return
                } else if(statusCode === 409) {
                    toast.error("There is a client with the same username and email address.")
                    return
                }
            }
            toast.error("Internal error")
        })
    }

    const handleSubmit = async e => {
        e.preventDefault()
        createClient()
    }

    const handleBack = async e => {
        e.preventDefault()
        navigate("/client")
    }

    return (
        <>
            <button className="btn btn-primary back" onClick={handleBack}>Back to overview</button><br /><br />

            <form className="form-horizontal" onSubmit={handleSubmit}>
                <div className="card card-primary">
                    <div className="card-body">
                        <div className="col-12">
                            <div className="row">
                                <div className="col-lg-6 col-12">
                                    <FormButton label="Username" id="username" required="required" value={username} setValue={setUsername} icon="fa-solid fa-user" labelSize="col-lg-3" size="col-lg-7" />
                                </div>
                                <div className="col-lg-6 col-12">
                                    <FormButton label="Email address" id="emailAddress" required="required" type="email" value={emailAddress} setValue={setEmailAddress} icon="fa-solid fa-envelope" labelSize="col-lg-3" size="col-lg-7" />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-3 col-12">
                                    <b>Provider</b>
                                    <Select options={options} onChange={(choice) => setProvider(choice.value)} />
                                    <br />
                                </div>
                                <div className="col-lg-3 col-12">
                                    <b>Duration</b>
                                    <Select options={durationOptions} onChange={(choice) => setDuration(choice.value)} />
                                </div>
                            </div>
                            
                            <div className="row">
                                <div className="col-lg-6 col-12">
                                    <FormButton label="Expiry date" id="expiryDate" type="date" value={expiryDate} setValue={setExpiryDate} icon="fa-solid fa-clock" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card-footer">
                        <button type="submit" className="btn btn-success">Create client</button>
                    </div>
                </div>
            </form>
        </>
    )
}
   
export default ClientCreate
